// OneDrive:IgnoreCodeCoverage

export const SPOTenantTokens = {
    ppe: "3620e5572cf04917bf4993285ebe4e15-d5c60963-35a1-45e2-9430-928e0656b9cd-6718",
    prod: "a9e9a63d9df4411ebbf89297947d7666-b5f0498b-a808-4b74-bb7b-2b33f7971660-7417"
};

export const ODBTenantTokens = {
    ppe: "f74c101dfd474d06a7b40fed2051df7e-edb10b9a-779e-4b75-b0cc-ee0cee0f831b-7189",
    prod: "af7114704a204580909f08c904c5ac6f-6f6f4c13-294c-4a00-8e55-71180ed7d627-7044"
};